// extracted by mini-css-extract-plugin
export default {"invisible":"registration-files-table_invisible__j7F9x","buttonText":"registration-files-table_buttonText__KS9Md"};